var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBackCover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.575,
    height: 108.011,
    viewBox: "0 0 68.575 108.011",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_189893",
    "data-name": "Group 189893",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Book",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42965",
    "data-name": "Path 42965",
    d: "M58.655,173.639,61.729,170a1.8,1.8,0,0,1,2.744,0l3.08,3.637a1.8,1.8,0,0,0,3.169-1.162V161.59H55.48v10.886a1.8,1.8,0,0,0,3.175,1.162Z",
    transform: "translate(-14.157 -70.323)",
    fill: "none",
    stroke: "#6a3089",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42966",
    "data-name": "Path 42966",
    d: "M42.11,43.735v61.3a1.8,1.8,0,0,0,1.8,1.8h60.98a1.8,1.8,0,0,0,1.8-1.8V25",
    transform: "translate(-42.11 -15.57)",
    fill: "none",
    stroke: "#f26e14",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42967",
    "data-name": "Path 42967",
    d: "M121.758,9.26H81.585a1.875,1.875,0,0,0-1.875,1.875V29.062",
    transform: "translate(-79.71 -9.26)",
    fill: "none",
    stroke: "#6f2f87",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42968",
    "data-name": "Path 42968",
    d: "M96.781,9.26H43.907a1.8,1.8,0,0,0-1.8,1.8V29.032H96.781a9.9,9.9,0,0,0,9.9-9.874h0a9.9,9.9,0,0,0-9.9-9.9Z",
    transform: "translate(-42.11 -9.26)",
    fill: "none",
    stroke: "#f26e14",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_44",
    "data-name": "Line 44",
    x1: 46.385,
    transform: "translate(9.095 9.898)",
    fill: "none",
    stroke: "#6a3089",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5596",
    "data-name": "Rectangle 5596",
    width: 52.724,
    height: 57.517,
    rx: 4,
    transform: "translate(5.859 27.415)",
    fill: "#f26e14"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBackCover);
export default __webpack_public_path__ + "static/media/icon-back-cover.49845e282fce8eaa0402e4100e214231.svg";
export { ForwardRef as ReactComponent };